import { useDispatch } from 'react-redux';
import { eventActions } from '../../../../store/modules/event';

const useExcel = (inProgressEvent) => {
  const dispatch = useDispatch();

  /**
   * 진행중인 기획전 리스트 엑셀 업로드
   */
  const getInProgressEventExcelDownload = () => {
    const { filterOption } = inProgressEvent.inProgressEventList;

    dispatch(
      eventActions.getInProgressEventExcelDownload({
        filterOption,
      }),
    );
  };

  return {
    getInProgressEventExcelDownload,
  };
};

export default useExcel;
